import { type OnboardingState } from "../types/onboardingState"
import { getDirectSteps, getMoveOutSteps, getSentQuoteDirectSteps } from "./getDirectSteps"
import { getNavigatorSteps } from "./getNavigatorSteps"
import { getTelesalesSteps } from "./getTelesalesSteps"

export function getOnboardingSteps(onboardingState: OnboardingState) {
    switch (onboardingState.formValues.subscriptionType) {
        case "NAVIGATOR":
            return getNavigatorSteps(onboardingState.formValues)
        case "CHECKOUT_PAGES":
            return getTelesalesSteps(onboardingState.formValues)
        case "EMAIL_QUOTE":
            return getSentQuoteDirectSteps(onboardingState.formValues)
        case "MOVE_OUT":
            return getMoveOutSteps(onboardingState.formValues)
        case "CROSS_SALE":
        case "DEFAULT":
        default:
            return getDirectSteps(onboardingState.formValues)
    }
}
